import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@shared/guards';
import { AddCustomerComponent } from './customer-add/customer-add.control';
import { EditCustomerComponent } from './customer-edit/customer-edit.control';
import { CustomerProfileComponent } from './customer-profile/customer-profile.control';
import { CustomersComponent } from './customers.control';
import { ProPageGuard } from '@shared/guards/pro/pro.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticationGuard, ProPageGuard],
    canActivateChild: [AuthenticationGuard],
    children: [
      {
        path: '',
        redirectTo: 'all',
        pathMatch: 'full'
      },
      {
        path: 'all',
        component: CustomersComponent
      },
      {
        path: 'active',
        component: CustomersComponent,
        data: { isArchived: false }
      },
      {
        path: 'archived',
        component: CustomersComponent,
        data: { isArchived: true }
      },
      {
        path: 'add',
        component: AddCustomerComponent,
        data: { title: 'Add A Customer' }
      },
      {
        path: 'edit/:customerUuid',
        component: EditCustomerComponent,
        data: { title: 'Edit Customer' }
      },
      {
        path: 'customer/:customerUuid',
        component: CustomerProfileComponent
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomersRoutingModule {}
